import { isTestEnvironment } from '../getVGSProxyEndpoint';

const getTourPublishableKey = (store) => {
  const settings =
    store.user && store.user.travelAgency && store.user.travelAgency.tourPaymentSettings;
  if (!settings) {
    return undefined;
  }

  const publishableKey = isTestEnvironment()
    ? settings.testPublishableKey
    : settings.publishableKey;
  return publishableKey || undefined;
};

export default getTourPublishableKey;
